import(/* webpackMode: "eager" */ "/codebuild/output/src3024251350/src/101yapi.com/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3024251350/src/101yapi.com/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["FraudProtection"] */ "/codebuild/output/src3024251350/src/101yapi.com/src/components/fraud/fraud-protection.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3024251350/src/101yapi.com/src/components/home-page/DiscountPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3024251350/src/101yapi.com/src/components/home-page/lazy-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3024251350/src/101yapi.com/src/components/home-page/popular-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3024251350/src/101yapi.com/src/components/home-page/products-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3024251350/src/101yapi.com/src/components/home-page/showcase-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3024251350/src/101yapi.com/src/modules/home/components/hero/hero-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3024251350/src/101yapi.com/src/modules/home/components/home-products-grid/title.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3024251350/src/101yapi.com/src/modules/products/components/product-preview/index.tsx");
